import { usePermanentHoldingLocations, usePermanentLocations } from "components/DealersAndLocationsDropdown/hooks";

import type { DealerLocationID } from "models";

export const useIsRobnetEnabled = (dealer_location_id?: DealerLocationID) => {
  const { locations } = usePermanentLocations();
  const { holdingLocations } = usePermanentHoldingLocations();

  if (!dealer_location_id) return false;

  const carLocation = locations.find(location => location.id === dealer_location_id) ?? holdingLocations.find(location => location.id === dealer_location_id);

  return carLocation?.is_robnet_enabled ?? false;
};
